export enum ACTION_TYPES {
  SET_DUE_DILIGENCE_STATUS = 'CM/CASE/DUE_DILIGENCE/SET_STATUS',
}
